import React from "react";

const ErrorPage = () => {
  return (
    <div className="">
      <h2 className="text-center text-4xl font-bold py-10">
        This page is not found
      </h2>
      <div className=" flex justify-center">
        <img
          className="w-1/2 flex justify-center"
          src="https://img.freepik.com/free-vector/error-404-concept-landing-page_52683-12757.jpg?w=1060&t=st=1669699236~exp=1669699836~hmac=b355348665793abd1266012bb634d820370ba448cda9be2ab6d5299ba58ac115"
          alt=""
        />
      </div>
    </div>
  );
};

export default ErrorPage;
<h2></h2>;
